import { useState,useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "../visitor/visitor-view/visitor-view.css";
import ModalCloseIcon from "../../assets/svg/close-modal.svg";
import info from "../../assets/svg/info.svg";
import { scheduleStatusUpdateApi } from "../visitor/visitor-api";
import SignaturePad from 'react-signature-pad-wrapper';
import { courierStatusUpdateApi } from "../courier/courier-api";

 const CourierReceivedModal = ({courierId,onSuccess,onCancel }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",          
          
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "680px",
          
          overflowY: "auto",
        },
      };
      useEffect(() => {
       
    },[]) 
    const sigCanvas = useRef({});
    const [selectedStatus, setSelectedStatus] = useState('pending'); 
    const [rejectReason, setRejectReason] = useState(''); 
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleTime, setScheduleTime] = useState("");
    const [imageURL, setImageURL] = useState(null);

    const handleChange = (event) => {
      setSelectedStatus(event.target.value);
    };

        const courierStatusUpdate = async () => {
          if (!sigCanvas.current.isEmpty()) {
            const dataURL = sigCanvas.current.toDataURL();
            console.log('Saved Signature Image:', dataURL);
          
                 const payload = {
                  "courier_id": courierId,
                  "status": "Received",
                  "signature": dataURL
                    
                  };
                  try {
                    const response = await courierStatusUpdateApi(payload);
                    if (response.statusCode === 400) {}
                    else{
                          if(response.data.status===true){                           
                            onSuccess(response.data)
                          }else{
                                 
                                }
                    }
                return response.data;
                  } catch (err) {
                    console.error("Error fetching category:", err);
                  } finally {
                  }
                } else {
                  alert("Please provide a signature first.");
                }
                };

 const clear = () => {
    sigCanvas.current.clear();
    setImageURL(null);
  };

  const save = () => {
    if (!sigCanvas.current.isEmpty()) {
      const trimmedCanvas = sigCanvas.current.getTrimmedCanvas(); // make sure this exists
      const base64 = trimmedCanvas.toDataURL('image/png');
      setImageURL(base64);
    } else {
      alert("Please provide a signature first.");
    }
  };
    return ( <div style={modalStyle.overlay}>
        <div style={modalStyle.modal}>
          <div style={{ color: "#ffffff" }}>
            <div>
            <div className="modal-header style-justify-between"
            >
              <div className="modal-title"
    >
    Update status
    </div>
    <img
                              src={ModalCloseIcon}
                              alt="Close"
                              onClick={onCancel}
                              style={{ cursor: "pointer",width: "30px", height: "30px", borderRadius: "50%" }}
                            />
      
            </div>
            <div className="px-3 py-3">
   <div className="style-justify-center" style={{gap:'8px'}}>
   <label className={`${selectedStatus === 'pending'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`} >
        <input
          type="radio"
          name="options"
          value="pending"
          checked={selectedStatus === 'pending'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'pending'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Pending</span>
  </label>

  <label className={`${selectedStatus === 'received'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>
        <input
          type="radio"
          name="options"
          value="received"
          checked={selectedStatus === 'received'}
          onChange={handleChange}
          className="custom-radio"
        />
        <span className={`px-2 ${selectedStatus === 'received'?'radio-btn-txt-active':'radio-btn-txt-inactive'}`}>Received</span>
  </label>



   </div>
   {selectedStatus === 'pending' && (<div className="mt-2">
     <img src={info} alt=""/> <span className="info-text">Select any status to update the status of this visitor</span>
   </div>)}

   {selectedStatus === 'received' && (<div>
<div className="field-title mb-1">Signature</div> 
                                                  <div style={{position: "relative",}}>

                                                  <SignaturePad 
        ref={sigCanvas} options={{  penColor: "black" }}
        canvasProps={{width:'632px', height:'124px',style: {borderRadius: '8px', border:'1.2px solid #2C8C53' },  }}
      />
                         {/* <span className="field-error">{validations.reason}</span> */}
                         <div style={{position:'absolute', top:'10px', right:'10px'}}>
                         <img
                              src={ModalCloseIcon}
                              alt="Close"
                              onClick={clear}
                              style={{ cursor: "pointer",width: "30px", height: "30px", borderRadius: "50%" }}
                            />
                         </div>
                      </div>
                   
</div>)}

{(selectedStatus === 'received') && (<Row className="mt-3"                
              >
                <div className="style-justify-end">
                <div
                  onClick={onCancel} className="admin-checklist-cancel-btn style-justify-center"                  
                >
                 Cancel
                </div>

               <div
                   onClick={()=>{courierStatusUpdate()}}  className="schedule-approve-btn style-justify-center px-5"                  
                >
                 Submit
                </div>
                </div>
              </Row>)}
   </div>
            </div>

          
          </div>
        </div>
      </div>);

}

export default CourierReceivedModal;